export default __webpack_public_path__ + "static/media/Tap-n-Charge.60cf6a61.jpg";